import React from 'react';
import { Formik, Form } from 'formik';
import NewDesign from 'components/NewDesign';
import Payment from 'pages/Settings/Tabs/Payment';
import getUser from 'redux/selector/getUser';
import UserModel from 'models/user.model';
import { CommonIcons } from 'components/Icons';
import { SIZE_ICON } from 'consts/data';
import CheckingBillingInformationProvider from 'providers/CheckingBillingInformationProvider';
import UserServices from 'services/UserServices';
import { AppRoutes } from 'consts/routesPath';

const propTypes = {};

const WarningMinBalancePage = (props) => {
  //! State
  const userInfo = getUser();

  //! Function
  const logout = () => {
    UserServices.clearUserCached();
    window.location.href = AppRoutes.Login;
  };

  //! Render
  return (
    <div className='component:WarningMinBalancePage'>
      <Formik
        enableReinitialize
        validateOnBlur={false}
        validateOnChange={false}
        initialValues={{
          ...UserModel.initialPaymentSetting(userInfo),
        }}
        onSubmit={() => {}}
      >
        {(propsFormik) => (
          <div
            style={{
              height: '100vh',
              overflow: 'auto',
              backgroundColor: 'var(--bg-color-main)',
            }}
            className='p-2'
          >
            <Form>
              <NewDesign.Alert color='primary' className='d-flex mobile:flex-column gap-8px'>
                <div className='flex-grow-1'>
                  <div style={{ maxWidth: 700 }}>
                    <NewDesign.Typography component='h5'>
                      Dear <b>{userInfo?.username}</b>,
                    </NewDesign.Typography>
                    <NewDesign.Typography component='p' className='mt-3'>
                      We regret to inform you that your current balance for using our platform is
                      insufficient. Due to this, you are currently unable to continue utilizing all
                      the features and services provided by our platform.
                    </NewDesign.Typography>

                    <NewDesign.Typography component='p' className='mt-2'>
                      We encourage you to top up your account balance as soon as possible so that
                      you can continue to enjoy our platform without any disruption. We also ensure
                      you that our payment options are fast, secure, and convenient for your use.
                    </NewDesign.Typography>
                    <NewDesign.Typography component='p' className='mt-2'>
                      We appreciate your patience and understanding, and we apologize for any
                      inconvenience this may have caused. Your continued support and patronage are
                      very important to us. We look forward to serving you better after your account
                      has been refilled.
                    </NewDesign.Typography>
                    <NewDesign.Typography component='p' className='mt-2'>
                      Thank you for choosing our platform!
                    </NewDesign.Typography>
                  </div>
                </div>

                <div className='flex-shrink-0'>
                  <NewDesign.Button
                    color='danger'
                    variant='text'
                    onClick={() => {
                      logout();
                    }}
                  >
                    <CommonIcons.SignOut size={SIZE_ICON} /> Logout
                  </NewDesign.Button>
                </div>
              </NewDesign.Alert>

              {userInfo.isLogged && (
                <div className='p-2'>
                  <Payment
                    skipCheckDirty={true}
                    noChangeTabURL={true}
                    disableAutoRecharge={true}
                    shouldOpenByPopup={true}
                  />
                </div>
              )}
            </Form>
          </div>
        )}
      </Formik>
    </div>
  );
};

WarningMinBalancePage.propTypes = propTypes;
export default (props) => {
  return (
    <CheckingBillingInformationProvider>
      <WarningMinBalancePage {...props} />
    </CheckingBillingInformationProvider>
  );
};
